import { Toast } from '~/components/atomic';
import useToast from '~/store/useToast';

const ToastProvider = () => {
  const toast = useToast();

  return (
    <div className='toast'>
      {toast.show && <Toast type={toast.type} text={toast.text} />}
    </div>
  );
};

export default ToastProvider;
